module.exports = __webpack_public_path__ + "static/media/briefcase-active.aedbd155.svg";